let activeTarget: HTMLElement | null = null;
let tooltip: HTMLDivElement | null = null;

function getLabel(target: HTMLElement): string {
    return target.dataset.tooltip || target.getAttribute('title') || target.dataset.tooltipTitle || '';
}

function positionTooltip(target: HTMLElement): void {
    if (!tooltip) return;
    const rect = target.getBoundingClientRect();
    const tipRect = tooltip.getBoundingClientRect();
    const gap = 9;
    const margin = 8;
    let left = rect.left + (rect.width - tipRect.width) / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - tipRect.width - margin));
    let top = rect.bottom + gap;
    if (top + tipRect.height > window.innerHeight - margin) {
        top = rect.top - tipRect.height - gap;
    }
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${Math.max(margin, top)}px`;
}

function show(target: HTMLElement): void {
    const label = getLabel(target);
    if (!label) return;
    hide();
    activeTarget = target;
    const nativeTitle = target.getAttribute('title');
    if (nativeTitle) {
        target.dataset.tooltipTitle = nativeTitle;
        target.removeAttribute('title');
    }
    tooltip = document.createElement('div');
    tooltip.className = 'viewport-tooltip';
    tooltip.textContent = label;
    tooltip.setAttribute('role', 'tooltip');
    document.body.appendChild(tooltip);
    positionTooltip(target);
    requestAnimationFrame(() => tooltip?.classList.add('is-visible'));
}

function hide(): void {
    if (activeTarget?.dataset.tooltipTitle) {
        activeTarget.setAttribute('title', activeTarget.dataset.tooltipTitle);
        delete activeTarget.dataset.tooltipTitle;
    }
    tooltip?.remove();
    tooltip = null;
    activeTarget = null;
}

function resolveTarget(value: EventTarget | null): HTMLElement | null {
    if (!(value instanceof Element)) return null;
    return value.closest<HTMLElement>('[title], [data-tooltip]');
}

export function initializeTooltips(): void {
    document.addEventListener('pointerover', event => {
        const target = resolveTarget(event.target);
        if (target && target !== activeTarget) show(target);
    });
    document.addEventListener('pointerout', event => {
        if (!activeTarget) return;
        const related = event.relatedTarget;
        if (related instanceof Node && activeTarget.contains(related)) return;
        if (resolveTarget(event.target) === activeTarget) hide();
    });
    document.addEventListener('focusin', event => {
        const target = resolveTarget(event.target);
        if (target) show(target);
    });
    document.addEventListener('focusout', event => {
        if (resolveTarget(event.target) === activeTarget) hide();
    });
    window.addEventListener('resize', hide);
    document.addEventListener('scroll', hide, true);
}
